export default __webpack_public_path__ + "static/media/Sumangali.96d28789.jpg";